<div class="flex flex-col justify-center items-center z-10">
    <div class="font-outfit text-3xl font-semibold mb-6 text-center px-4">
        from mobile <span class="gradient-text">strategy</span> to a shipping app
    </div>
    <div class="px-4 sm:px-[20%] text-center text-sm sm:text-base relative z-10">
        We help B2B and B2C companies turn a mobile idea into a working product. From market validation
        and feature scoping to a fully shipped iOS and Android app, we partner with you end-to-end — so you
        don't have to assemble a strategy team, a design firm, and a development shop separately. The result
        is a mobile product that ships on time and earns its place in your customers' phones.
    </div>
</div>
